var _rect, _rect2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicatePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 13,
    rx: 1.5,
    stroke: "#737373",
    strokeWidth: 1.5,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 11,
    height: 13,
    rx: 1.5,
    stroke: "#737373",
    strokeWidth: 1.5,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 11,
    x2: 13,
    y2: 11,
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.25,
    y1: 8.25,
    x2: 10.25,
    y2: 13.75,
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatePlusIcon);
export default __webpack_public_path__ + "static/media/duplicate-plus-icon.dc429c0d4338aa65eed2e0523c05d011.svg";
export { ForwardRef as ReactComponent };